var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content !== null)?_c('section',{class:_vm.sectionClass,domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('section',{class:_vm.sectionClass},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }